import React, { useEffect, useRef } from "react";
import HeroVideo from "../components/HeroVideo";
import ImageText1 from "../components/ImageText";
import { cardsData } from "../utils/cardsData";
import { galleryImages } from "../utils/galleryData";
import imageUrl from "../assets/images/homecar.png";
import ServicesCard from "../components/Cards/ServicesCards";
import RunningCar from "../components/RunningCar";
import ImagesSlider from "../components/ImagesSlider";
import GoogleReviews from "../components/Reviews.tsx";
import CarForm from "../components/CarForm.jsx";

function Home() {
  // useEffect(() => {
  //   window.scrollTo(0, 0);
  // }, []);

  const carFormRef = useRef(null);

  useEffect(() => {
    // Check if mobile screen
    // const isMobile = window.innerWidth <= 768;

    if (carFormRef.current) { // isMobile && 
      carFormRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, []);

  // Select specific items from the cardsData array
  const selectedCardsData = cardsData.filter(
    (card) =>
      card.title === "STAGE 1 CHIPTUNING" ||
      card.title === "HARD REV CUT" ||
      card.title === "EGR SOLUTIONS" ||
      card.title === "DTC REMOVAL" ||
      card.title === "DSG / AUTOMAAT TUNING" ||
      card.title === "ECO TUNING",
  );

  const text1 = (
    <>
      <h2 className="text-4xl font-bold text-center text-white pb-8">
        Wat je kunt verwachten bij X-tremetunings
      </h2>
      <br />
      <h3 className="font-semibold">- Expertise en ervaring</h3>
      <p>
        x-tremetunings heeft uitgebreide ervaring en vakkennis in de
        tuning-industrie. Dit betekent dat je kunt rekenen op technische
        expertise bij elke upgrade die wij aanbieden.
      </p>
      <br />
      <h3 className="font-semibold">- Maatwerk</h3>
      <p>
        Wij bieden op maat gemaakte oplossingen die perfect aansluiten bij de
        wensen van de klant. Dit zorgt ervoor dat je tuningervaring echt uniek
        is en afgestemd op jouw specifieke behoeften.
      </p>
      <br />
      <h3 className="font-semibold">- Kwaliteit en betrouwbaarheid</h3>
      <p>
        {" "}
        x-tremetunings staat bekend om het leveren van kwalitatief hoogstaande
        tuningsdiensten. Wij gebruiken enkel de beste apparatuur en
        technologieën, wat resulteert in betrouwbare aanpassingen.
      </p>
      <br />
      <h3 className="font-semibold">- Persoonlijke service</h3>
      <p>
        {" "}
        Klanten waarderen vaak de persoonlijke benadering van x-tremetunings.
        Wij nemen de tijd om te luisteren naar je wensen en zorgen ervoor dat je
        altijd goed geïnformeerd bent over de keuzes die je maakt voor je auto.
      </p>
      <br />
      <h3 className="font-semibold">- Breed scala aan diensten</h3>
      <p>
        {" "}
        Of je nu geïnteresseerd bent in prestatieverbeteringen, visuele
        upgrades, of onderhoudsdiensten, x-tremetunings biedt een breed scala
        aan mogelijkheden om je voertuig te optimaliseren.
      </p>
    </>
  );
  return (
    <div className="overflow-x-hidden bg-black">
      <HeroVideo />
      <ServicesCard cards={selectedCardsData} />
      {/* <PerformanceForm carData={carData} /> */}
      <div ref={carFormRef}>
        <CarForm />
      </div>
      {/* <VideoCards cards={selectedCardsData} /> */}

      <RunningCar />
      {/* <ScrollVideo /> */}
      <ImageText1 imageUrl={imageUrl} text={text1} />
      <ImagesSlider images={galleryImages} showButton="true" />
      {/* <ImagesSection images={images} showButton="true" /> */}
      <GoogleReviews />
    </div>
  );
}

export default Home;
